import { useState } from "react";

export const useToggle = (initialState = false): [boolean, () => void, () => void, () => void] => {
    const [state, setState] = useState(initialState);

    const toggle = () => setState((prevState) => !prevState);
    const setTrue = () => setState(true);
    const setFalse = () => setState(false);

    return [state, setTrue, setFalse, toggle];
};
